<div class="content-wrapper">
  <div class="row">
    <div class="col-md-12 grid-margin">
      <div class="row">
        <div class="col-12 col-xl-8 mb-4 mb-xl-0">
          <h3 class="font-weight-bold">Welcome {{ fullName }}!</h3>
        </div>
        <div class="col-12 col-xl-4">
          <div class="justify-content-end d-flex">
            <div class="dropdown flex-md-grow-1 flex-xl-grow-0">
              <button class="btn btn-sm btn-light bg-white" type="button">
                <i class="mdi mdi-calendar"></i> Today ( {{ today | date : 'dd MMM yyyy'}} )
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div  class="row" *ngIf="showRequestsMenu">

    <div (click)="showFilteredRequests('New')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card text-white bg-secondary">
        <div class="card-body">
          <p class="mb-4">New Request(s)</p>
          <p class="fs-30 mb-2">{{ NewRequests }}</p>
        </div>
      </div>
    </div>

    <div (click)="showFilteredRequests('Pending')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card card-light-blue">
        <div class="card-body">
          <p class="mb-4">Contract Pending Request(s)</p>
          <p class="fs-30 mb-2">{{ PendingRequests }}</p>
        </div>
      </div>
    </div>
    
    <div (click)="showFilteredRequests('Approved')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card text-white bg-success">
        <div class="card-body">
          <p class="mb-4">Approved Request(s)</p>
          <p class="fs-30 mb-2">{{ ApprovedRequests }}</p>
        </div>
      </div>
    </div>

    <div (click)="showFilteredRequests('Active')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card card-dark-blue">
        <div class="card-body">
          <p class="mb-4">Active Request(s)</p>
          <p class="fs-30 mb-2">{{ ActiveRequests }}</p>
        </div>
      </div>
    </div>

    <div routerLink="/approverequests" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="!canAddRequest && showRequestsMenu">
      <div class="card card-dark-blue">
        <div class="card-body">
          <p class="mb-4">Contract Pending My Approval</p>
          <p class="fs-30 mb-2">{{ PendingApprovals }}</p>
          <p></p>
        </div>
      </div>
    </div>

    <div (click)="showFilteredRequests('Rejected')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card text-white bg-dark">
        <div class="card-body">
          <p class="mb-4">Rejected Requests</p>
          <p class="fs-30 mb-2">{{ RejectedRequests }}</p>
          <p></p>
        </div>
      </div>
    </div>

    <div (click)="showFilteredRequests('Expiring')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card text-white bg-warning">
        <div class="card-body">
          <p class="mb-4">Requests Expiring in {{today | date: 'MMMM'}}</p>
          <p class="fs-30 mb-2">{{ ExpiringRequests }}</p>
          <p></p>
        </div>
      </div>
    </div>

    <div (click)="showFilteredRequests('Expired')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card text-white bg-danger">
        <div class="card-body">
          <p class="mb-4">Expired Request(s)</p>
          <p class="fs-30 mb-2">{{ ExpiredRequests }}</p>
          <p></p>
        </div>
      </div>
    </div>

    <div (click)="showFilteredRequests('PendingPO')" class="col-md-3 mb-4 stretch-card transparent clickable" *ngIf="canAddRequest">
      <div class="card text-white bg-secondary">
        <div class="card-body">
          <p class="mb-4">Express Request Pending PO Number</p>
          <p class="fs-30 mb-2">{{ MissingPO }}</p>
          <p></p>
        </div>
      </div>
    </div>

    <div  routerLink="/approvemanpowerrequests" class="col-md-3 mb-4 stretch-card transparent clickable" >
      <div class="card card-light-blue">
        <div class="card-body">
          <p class="mb-4">Man Power Pending My Approval</p>
          <p class="fs-30 mb-2">{{ manPowerpendingRequestCount }}</p>
        </div>
      </div>
    </div>
    

    <div routerLink="/approvemovementrequests"  class="col-md-3 mb-4 stretch-card transparent clickable" >
      <div class="card card-light-blue">
        <div class="card-body">
          <p class="mb-4">Movement Pending My Approval</p>
          <p class="fs-30 mb-2">{{ movementpendingRequestCount }}</p>
        </div>
      </div>
    </div>

   

    <div routerLink="/manpowerrequest" class="col-md-3 mb-4 stretch-card transparent clickable" >
      <div class="card text-white bg-secondary">
        <div class="card-body">
          <p class="mb-4">New ManPower Request</p>
          <p class="fs-30 mb-2">{{ manPowerNewRequestCount }}</p>
        </div>
      </div>
    </div>

    <div routerLink="/movementrequest"  class="col-md-3 mb-4 stretch-card transparent clickable" >
      <div class="card text-white bg-secondary">
        <div class="card-body">
          <p class="mb-4">New Movement Request</p>
          <p class="fs-30 mb-2">{{ movementpendingRequestCount }}</p>
        </div>
      </div>
    </div>
    
  </div>
</div>
<!-- main-panel ends -->